import { provideGalaxyDateAdapter } from '@vendasta/galaxy/datepicker';
import { Component } from '@angular/core';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';

@Component({
  template: `
    <div class="value">
      {{ value | glxyDate: format }}
    </div>
  `,
  providers: [provideGalaxyDateAdapter()],
  standalone: false,
})
export class TimestampRendererComponent {
  format = DateFormat.medium;
  value: Date = new Date(0);
}
